module.exports = __webpack_public_path__ + "static/media/GUNS-BNB.df21780e.png";